export const RUNNING: string = 'running';
export const OUTPUT_LIMIT: number = 5000;

export const CONSOLE_CLEAR: string = 'CONSOLE_CLEAR';
export const CONSOLE_RESULT: string = 'CONSOLE_RESULT';

